import React from 'react';
import MuiMenuItem from '@mui/material/MenuItem';

const MenuItem = ({ children, ...props }) => {
  return (
    <MuiMenuItem {...props}>
      {children}
    </MuiMenuItem>
  );
};

export default MenuItem;

